import classnames from 'classnames';
import './layout.scss';
import { FCC } from '../../../utils/types';
import '../../routes/campaign/campaign.scss';
// TODO: fix css
import styles from './MainTitle.module.css';

interface Props {
  isCampaignTitle?: boolean;
  hasSubtitle?: boolean;
  className?: string;
}

const MainTitle: FCC<Props> = ({ children, isCampaignTitle = false, hasSubtitle = false, className = '' }) => {
  const mainClass = classnames(styles.mainTitle, className);

  return isCampaignTitle ? (
    <h1 className={`${styles.campaignTitle} ${hasSubtitle && styles.withSubtitle}`}>{children}</h1>
  ) : (
    <h2 className={mainClass}>{children}</h2>
  );
};

export default MainTitle;
